import { Link } from 'foundations-components/transitional/components/Link';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler, useLinkClickHandler } from './FrequentlyAskedQuestionsUtils';
import { getAcademyUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMarketingUrlPublic, getNonProfitsUrlPublic, getStartupsUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const marketingHref = getMarketingUrlPublic();
const startupsHref = getStartupsUrlPublic('pricing-marketingpage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-marketingpage');
export const MarketingHubFaqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatIsMarketing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatIsMarketing.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          marketingLink: /*#__PURE__*/_jsx(Link, {
            href: marketingHref,
            external: true,
            onClick: () => handleLinkClick('marketing.whatIsMarketing', marketingHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatIsMarketing.learnMore"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('marketing.whatIsMarketing', 'pricing-page-components.frequentlyAskedQuestions.marketing.whatIsMarketing.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatAreMarketingContacts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatAreMarketingContacts.answer"
      }),
      onExpandedChange: () => handleFaqToggle('marketing.whatAreMarketingContacts', 'pricing-page-components.frequentlyAskedQuestions.marketing.whatAreMarketingContacts.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyContacts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyContacts.answer"
      }),
      onExpandedChange: () => handleFaqToggle('marketing.howManyContacts', 'pricing-page-components.frequentlyAskedQuestions.marketing.howManyContacts.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyEmails.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyEmails.answer"
      }),
      onExpandedChange: () => handleFaqToggle('marketing.howManyEmails', 'pricing-page-components.frequentlyAskedQuestions.marketing.howManyEmails.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.marketingRequiredOnboarding.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.marketingRequiredOnboarding.answer"
      }),
      onExpandedChange: () => handleFaqToggle('marketing.marketingRequiredOnboarding', 'pricing-page-components.frequentlyAskedQuestions.marketing.marketingRequiredOnboarding.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: () => handleLinkClick('marketing.whatSupport.hubSpotCommunity', communityHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.hubSpotCommunity"
            })
          }),
          languageLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: () => handleLinkClick('marketing.whatSupport.languageOffering', langHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.languageOffering"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: () => handleLinkClick('marketing.whatSupport.hubSpotAcademy', academyHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: () => handleLinkClick('marketing.whatSupport.hubSpotKnowledgeBase', kbHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.hubSpotKnowledgeBase"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('marketing.whatSupport', 'pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: () => handleLinkClick('marketing.whatDiscounts.hubSpotForStartups', startupsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.hubSpotForStartups"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: () => handleLinkClick('marketing.whatDiscounts.hubSpotForNonprofits', nonprofitsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.hubSpotForNonprofits"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('marketing.whatDiscounts', 'pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whenEligibleForNewPricing.answer"
      }),
      onExpandedChange: () => handleFaqToggle('marketing.whenEligibleForNewPricing', 'pricing-page-components.frequentlyAskedQuestions.marketing.whenEligibleForNewPricing.question')
    })]
  });
};